import React from 'react';
import '../../../../App.css';
import '../SectionC.css';
import SectionC1Cards from './SectionC1Cards';
import Footer from '../../../Footer'

export default function SectionC1() {
    return(
        <>
        <div class = 'cont'>
            <h1 className = 'section-c-title'>Experiment A1: potential divider circuit using a potentiometer</h1>
        </div>
        <SectionC1Cards/>
        <Footer />
        </>
    )
}
